module.exports = __webpack_public_path__ + "img/AVELogo.d0461f07.svg";